export const getMaskedEmail = (value: string | null | undefined) => {
  if (!value) return ''

  const arr = (value.split('@')[1] || '')
    .split('.')
    .map((v, i, a) => {
      if (i === 0) return `${v.substr(0, 1)}${v.substr(1).replace(/./g, '*')}`
      if (i === a.length - 1) return v
      return v.replace(/./g, '*')
    })

  return `*@${arr.join('.')}`
}

export const getMasketPhone = (value: string | null | undefined) => {
  if (!value) return ''
  return value.replace(/\d(?=\d{4})/g, '*')
}
